// import { Calendar } from 'fullcalendar'

// Basic Setup ↓
import './components/_1_collapse.js';
import './components/_1_custom-select.js';
import './components/_1_details.js';
import './components/_1_diagonal-movement.js';
import './components/_1_modal-window.js';
import './custom/_1_read-more.js';
import './components/_1_reveal-effects.js';
import './components/_1_swipe-content.js';
import './components/_1_tabs.js';
import './components/_2_carousel.js';
import './components/_2_dropdown.js';
import './components/_2_points-of-interest.js';
import './components/_2_slideshow.js';
import './components/_1_menu.js';
import './components/_2_menu-bar.js';
import './components/_3_lightbox.js';
import './components/_1_popover.js';
import './components/_1_filter.js';
import './components/_3_advanced-filter.js';
import './components/_2_grid-switch.js';
import './components/_3_expandable-img-gallery.js';
import './components/_2_pricing-table.js';
import './components/_1_confetti-button.js';
import './components/_1_accordion.js';
import './components/_1_tabs.js';
import './components/_1_expandable-table.js';
import './components/_2_copy-to-clipboard.js';
import './components/_3_looping-slideshow.js';
import './components/_1_lazy-load.js';


// Navigations ↓
import './components/_1_anim-menu-btn.js';
import './components/_2_flexi-header.js';
import './components/_3_mega-site-navigation.js';
import './components/_1_drawer.js';
import './components/_2_drawer-navigation.js';
import './components/_1_responsive-sidebar.js';
import './components/_2_side-navigation-v4.js';

const panel = document.getElementById('filter-panel');

/**
 * Appends the current location URL with query parameters based on selected filters
 */
panel.addEventListener('click', function (event) {

    let url = new URL(window.location);

    const target = event.target;

    if (target.tagName === 'INPUT') {

        const category = event.target.dataset.category;
        const filter = event.target.dataset.filter;

        if (target.checked) {

            url.searchParams.append(`${category}[]`, filter);

            history.pushState({}, 'Posts', url);

        } else {

            url.searchParams.delete(`${category}[]`, filter);

            history.pushState({}, document.title, url);
        }
    }
});